<template>
    <v-container fluid class="pa-0">
        <v-row no-gutters justify="center" align="stretch">
            <!-- Available Items Col -->
            <v-col cols="12" :md="typeVertical ? 12 : 5">
                <v-card outlined class="rounded-xl border-soft shadow-sm overflow-hidden h-full">
                    <div class="px-4 py-3 bg-light-soft d-flex align-center justify-space-between border-bottom-soft">
                        <div class="d-flex align-center">
                            <v-icon color="primary" class="mr-2" small>mdi-format-list-bulleted</v-icon>
                            <span class="text-subtitle-2 font-weight-black grey--text text--darken-3">{{
                                title.all.toUpperCase() }}</span>
                        </div>
                        <v-chip x-small color="primary lighten-5" text-color="primary" class="font-weight-black">
                            {{ getItemAvailable.length }} DISPONIBLES
                        </v-chip>
                    </div>

                    <div class="px-4 py-2 bg-white">
                        <v-text-field v-model="searchAll" prepend-inner-icon="mdi-magnify" label="Buscar disponible..."
                            outlined dense hide-details rounded class="search-field"></v-text-field>
                    </div>

                    <v-divider></v-divider>

                    <v-data-table :items-per-page="hide_footer ? -1 : 10" :headers="headers" :search="searchAll"
                        :items="getItemAvailable" :hide-default-footer="hide_footer" :height="vh_height" fixed-header
                        dense class="custom-table iterator-table" no-data-text="No hay elementos disponibles">
                        <template v-slot:[`item.id`]="{ item }">
                            <span class="grey--text font-weight-bold text-caption">{{ item.id }}</span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                            <span class="text-body-2 font-weight-medium grey--text text--darken-3">{{ item.name
                                }}</span>
                        </template>
                        <template v-slot:[`item.agre`]="{ item }">
                            <v-btn icon small color="success" class="bg-green-soft rounded-lg" @click="move(item, 1)">
                                <v-icon small>{{ typeVertical ? 'mdi-arrow-down' : 'mdi-arrow-right' }}</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>

            <!-- Control Buttons Col -->
            <v-col cols="12" :md="typeVertical ? 12 : 1" class="d-flex align-center justify-center">
                <div :class="['d-flex', typeVertical ? 'flex-row pa-2' : 'flex-column', 'gap-2']">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="primary" depressed fab x-small class="shadow-sm"
                                @click="moveAll('right')">
                                <v-icon>{{ typeVertical ? 'mdi-chevron-double-down' : 'mdi-chevron-double-right'
                                    }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Agregar todo</span>
                    </v-tooltip>

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" color="error" depressed fab x-small class="shadow-sm"
                                @click="moveAll('left')">
                                <v-icon>{{ typeVertical ? 'mdi-chevron-double-up' : 'mdi-chevron-double-left'
                                    }}</v-icon>
                            </v-btn>
                        </template>
                        <span>Quitar todo</span>
                    </v-tooltip>
                </div>
            </v-col>

            <!-- Selected Items Col -->
            <v-col cols="12" :md="typeVertical ? 12 : 5">
                <v-card outlined class="rounded-xl border-soft shadow-sm overflow-hidden h-full">
                    <div class="px-4 py-3 bg-light-soft d-flex align-center justify-space-between border-bottom-soft">
                        <div class="d-flex align-center">
                            <v-icon color="success" class="mr-2" small>mdi-check-circle</v-icon>
                            <span class="text-subtitle-2 font-weight-black grey--text text--darken-3">{{
                                title.selected.toUpperCase() }}</span>
                        </div>
                        <v-chip x-small color="success lighten-5" text-color="success" class="font-weight-black">
                            {{ getItemSelected.length }} SELECCIONADOS
                        </v-chip>
                    </div>

                    <div class="px-4 py-2 bg-white">
                        <v-text-field v-model="searchSelected" prepend-inner-icon="mdi-magnify"
                            label="Buscar seleccionado..." outlined dense hide-details rounded
                            class="search-field"></v-text-field>
                    </div>

                    <v-divider></v-divider>

                    <v-data-table :items-per-page="hide_footer ? -1 : 10" :headers="headerSelected"
                        :search="searchSelected" :hide-default-footer="hide_footer" :items="getItemSelected"
                        :height="vh_height" fixed-header dense class="custom-table iterator-table"
                        no-data-text="Sin selecciones activas">
                        <template v-slot:[`item.put_off`]="{ item }">
                            <v-btn icon small color="error" class="bg-orange-soft rounded-lg" @click="move(item, 2)">
                                <v-icon small>{{ typeVertical ? 'mdi-arrow-up' : 'mdi-arrow-left' }}</v-icon>
                            </v-btn>
                        </template>
                        <template v-slot:[`item.id`]="{ item }">
                            <span class="grey--text font-weight-bold text-caption">{{ item.id }}</span>
                        </template>
                        <template v-slot:[`item.name`]="{ item }">
                            <span class="text-body-2 font-weight-medium grey--text text--darken-3">{{ item.name
                                }}</span>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "DataIterator",
    props: {
        all_items: {
            type: Array,
            default: () => []
        },
        items_selected: {
            type: Array,
            default: () => []
        },
        title: {
            type: Object,
            default: () => ({
                all: 'Disponibles',
                selected: 'Seleccionados'
            })
        },
        typeVertical: {
            type: Boolean,
            default: false
        },
        hide_footer: {
            type: Boolean,
            default: false
        },
        vh_height: {
            type: String,
            default: '30vh'
        },
    },
    data: () => ({
        allItems: [],
        searchAll: '',
        searchSelected: '',
        headers: [
            { text: "ID", align: "start", value: "id", width: "80px" },
            { text: "DESCRIPCIÓN", value: "name" },
            { text: "", value: "agre", sortable: false, width: "50px", align: 'end' },
        ],
        headerSelected: [
            { text: "", value: "put_off", sortable: false, width: "50px", align: 'start' },
            { text: "ID", align: "start", value: "id", width: "80px" },
            { text: "DESCRIPCIÓN", value: "name" },
        ],
    }),
    mounted() {
        this.initialized()
    },
    computed: {
        getItemAvailable() {
            return this.allItems.filter((element) => !this.items_selected.includes(element.id));
        },
        getItemSelected() {
            return this.allItems.filter((element) => this.items_selected.includes(element.id));
        }
    },
    methods: {
        initialized() {
            this.allItems = Object.assign([], this.all_items);
        },
        move(item, type) {
            if (type == 1) {
                if (!this.items_selected.includes(item.id)) {
                    this.items_selected.push(item.id);
                }
                return;
            }

            let index = this.items_selected.indexOf(item.id);
            if (index !== -1) {
                this.items_selected.splice(index, 1);
            }
        },
        moveAll(type) {
            if (type == 'right') {
                const availableIds = this.getItemAvailable.map(i => i.id);
                this.items_selected.push(...availableIds);
                return;
            }
            this.items_selected.splice(0, this.items_selected.length);
        }
    }
}
</script>

<style scoped>
.bg-light-soft {
    background-color: #f8fafd !important;
}

.bg-green-soft {
    background-color: rgba(76, 175, 80, 0.08) !important;
}

.bg-orange-soft {
    background-color: rgba(255, 87, 34, 0.08) !important;
}

.border-soft {
    border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.border-bottom-soft {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.shadow-sm {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03) !important;
}

.rounded-xl {
    border-radius: 12px !important;
}

.gap-2 {
    gap: 8px;
}

.search-field>>>.v-input__control>>>.v-input__slot {
    background-color: #f1f3f6 !important;
    border: none !important;
}

.iterator-table {
    background: transparent !important;
}

.iterator-table>>>th {
    background-color: #f8fafd !important;
    font-size: 0.7rem !important;
    font-weight: 800 !important;
    color: #78909c !important;
    letter-spacing: 0.5px;
    height: 40px !important;
}

.iterator-table>>>td {
    height: 48px !important;
}

.iterator-table>>>.v-data-table__wrapper {
    overflow-y: auto;
}

.iterator-table>>>tr:hover {
    background-color: rgba(25, 118, 210, 0.02) !important;
}

.h-full {
    height: 100% !important;
}
</style>